import Button from "@material-ui/core/Button/Button";
import Grid from "@material-ui/core/Grid/Grid";
import Typography from "@material-ui/core/Typography";
import { Fragment, useState } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "@common/Modal/Modal";
import { useCancelPortIn } from "./hook/useCancelPortIn";
import { PortInState } from "./interface/IPortIn";
import { Loader } from "@common/handleErrorAndLoading/Loader";
import { BRAND_NAME } from "@constants";

interface IParams {
    portInId?: number;
    portInState: PortInState;
    getPortInDetails(): void;
    handleEditPortIn(): void;
}

export const PortInAction = (props: IParams) => {
    const [isCancelPortInModalOpen, setIsCancelPortInModalOpen] = useState(false);
    const { handleEditPortIn, portInState, portInId, getPortInDetails } = props;

    const { t } = useTranslation(["portinPage", "common"]);

    const { handleCancelPortIn, cancelPortInState } = useCancelPortIn(getPortInDetails, portInId);

    const cancelPortin = () => {
        setIsCancelPortInModalOpen(false);
        handleCancelPortIn();
    };

    return (
        <Fragment>
            <Modal
                close={() => setIsCancelPortInModalOpen(false)}
                confirm={cancelPortin}
                content={t("portinPage:cancelPortinHelper", { brand: BRAND_NAME })}
                isModalOpen={isCancelPortInModalOpen}
                title={t("portinPage:wantCancelMove")}
            />
            {cancelPortInState.isLoading && <Loader size={40} />}
            {!cancelPortInState.isLoading && (
                <Grid container justify="center" spacing={4}>
                    {portInState !== PortInState.IN_PROGRESS && (
                        <Grid item md={3} sm={4} xs={8}>
                            <Button
                                color="secondary"
                                fullWidth
                                size="large"
                                variant="outlined"
                                onClick={() => setIsCancelPortInModalOpen(true)}
                            >
                                {t("portinPage:cancelMove")}
                            </Button>
                        </Grid>
                    )}
                    {portInState === PortInState.SCHEDULED && (
                        <Grid item md={3} sm={4} xs={8}>
                            <Button
                                color="secondary"
                                fullWidth
                                size="large"
                                variant="outlined"
                                onClick={handleEditPortIn}
                            >
                                {t("portinPage:updateMove")}
                            </Button>
                        </Grid>
                    )}
                </Grid>
            )}
            {cancelPortInState.error && (
                <Typography color="error">
                    {cancelPortInState.error.errorMessage || t("common:genericError")}
                </Typography>
            )}
        </Fragment>
    );
};
